module.exports = __webpack_public_path__ + "media/images/emblems/Rehetobe-7608cb87c25ec35e20e9ec5dc8f41285.png";